<script>
    import {
        InputPassword,
        Typography,
        Spinner,
        InputText,
        Button,
        Alert
    } from '$lib/components/UI'
    import userLogo from '../assets/pictures/e11-man-profile.svg'
    import Redirect from '$lib/components/layout/Redirect.svelte'
    import { useParams, navigate, useLocation } from 'svelte-navigator'
    import { API_URL } from '$lib/conf'
    import Frame from '$lib/components/layout/Frame.svelte'
    const params = useParams()
    const location = useLocation()
    let data = {}
    let pin = ''
    let validPin = false
    let token = null
    let tries = 5
    let validPassword,
        validPassword2,
        blockButton = false
    $: challengeId = $location.state?.challenge
    function fetchChallenge() {
        return fetch(
            `${API_URL}/challenge/${challengeId}`,
            {
                method: 'POST',
                body: JSON.stringify({pin}),
                // headers: {
                //     'Content-Type': 'application/json'
                // }
            }
        ).then(async (r) => {
            console.log('r.ok?: ', r.ok)
            if (r.ok) {
                let ret = await r.json()
                token = ret.token
            } else {
                let ret = await r.text()
                if (/^failed.*$/i.test(ret)) {
                    --tries
                } else if (/maximum.*number.*reached./i.test(ret)) {
                    navigate('/result', {state: {
                        title: 'Agotaste la cantidad permitida de intentos',
                        desc: 'Por favor solicitá otro código desde la interfaz de inicio de sesión.',
                        icon: 'faceIDNegative',
                        buttonSet: [
                            {
                                navTo: '/login',
                                label: 'Ir a Inicio de Sesión',
                            },
                        ]
                    }})
                } else if (/invalid.*data.*/i.test(ret)) {
                    navigate('/result', {state: {
                        title: 'Ocurrió un error',
                        desc: 'Por favor solicitá otro código desde la interfaz de inicio de sesión.',
                        icon: 'faceIDNegative',
                        buttonSet: [
                            {
                                navTo: '/login',
                                label: 'Ir a Inicio de Sesión',
                            },
                        ]
                    }})
                }
            }
        })
    }

    function send(token) {
        blockButton = true
        fetch(`${API_URL}/users`, {
            method: 'PUT',
            body: JSON.stringify({
                password: data.password,
                token,
            }),
        })
            .then(async (res) => {
                if (res.ok) {
                    blockButton = false
                    navigate('/result', {
                        state: {
                            title: 'Tu contraseña se modificó correctamente',
                            desc: 'Esta es la contraseña que deberás usar la próxima vez que inicies sesión.',
                            icon: 'mailPositive',
                            buttonSet: [
                                {
                                    navTo: '/login',
                                    label: 'Iniciar sesión',
                                },
                            ],
                        },
                    })
                } else {
                    throw new Error('Error al intentar cambiar la contraseña')
                }
            })
            .catch((err) => {
                console.log(err)
                blockButton = false
            })
    }
</script>

<Frame background="grey" style="padding: 56px 0">
    {#if !($location.state?.email && $location.state?.challenge)}
        <Redirect path="/result" options={{
            state: {
                title: 'Ocurrió un error',
                desc: 'Por favor solicitá otro código desde la interfaz de inicio de sesión.',
                icon: 'faceIDNegative'
            }
        }}/>
    {:else if token == null}
        <div style="width: 75%;">
            <Typography>{`Ingrese el código de verificación que enviamos a ${$location.state?.email}`}</Typography>
            <InputText
                label="Código de verificación"
                bind:value={pin}
                maxLength={6}
                validation={pin => pin && pin.length == 6 && /[0-9]+/.test(pin)}
                bind:valid={validPin}
                on:keypress={({detail: {eventTarget: {key}}}) => {                    
                    if(key == 'Enter' && validPin) fetchChallenge()
                }}
            />
            <Button disabled={!validPin} on:click={fetchChallenge}>Enviar</Button>
            {#if tries < 5}
                <Alert type="error">El código de verificación es incorrecto. Te quedan {tries} intentos.</Alert>
            {/if}
        </div>
        <!-- <p>{JSON.stringify({$location})}</p> -->
    {:else}
        <div>
            <!-- <Avatar {name} /> -->
            <img src={userLogo} draggable="false" alt="" />
            <Typography
                type="h3"
                style="text-align: center;margin: 0; padding: 0"
                >Cambio de contraseña</Typography
            >
            <Typography
                type="body"
                style="text-align: center;margin: 0; padding: 0"
                color="grey-800"
                >Por favor ingresá tu nueva contraseña.</Typography
            >
            <!-- {name.split(" ").at(0)} -->
            <InputPassword
                label="Contraseña"
                signUp
                bind:value={data.password}
                bind:valid={validPassword}
                validations={[
                    {
                        helper: 'Debe tener al menos 8 caracteres',
                        func: (v) => v && v.length >= 8,
                    },
                    {
                        helper: 'Usa al menos un número o símbolo.',
                        func: (v) => v && v.match(/\d|\W|\s/),
                    },
                    // {
                    //     helper: "No debe contener tu nombre u apellido.",
                    //     func: (v) => v && v.length > 3
                    // },
                ]}
                errorMsg="Password most be at the same."
            />
            <InputPassword
                label="Repita contraseña"
                bind:valid={validPassword2}
                validation={(v) => v === data.password}
                errorMsg="Las contraseñas deben coincidir"
            />
            <Button
                disabled={!(!blockButton && validPassword && validPassword2)}
                on:click={(_) => send(token)}
                label="Guardar"
                style="width: 100%"
            />
        </div>
    {/if}
    <!-- {:catch err}
        <Redirect
            path="/result"
            options={{
                state: {
                    title: 'Ocurrió un error.',
                    desc: 'Puede que ésta solicitud esté caducada, recordá que el enlace para recuperar la contraseña dura 15 minutos.',
                    icon: 'mailNegative',
                    buttonSet: [
                        { navTo: '/login', label: 'Generar uno nuevo' },
                    ],
                },
            }}
        />
    {/await} -->
</Frame>

<style>
    div {
        width: 596px;
        /* height: 100%; */
        display: flex;
        position: relative;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        display: flex;
        margin: auto;
        align-items: center;
        padding: 48px 111px;
        gap: 10px;
        align-self: center;
        border: 1px solid #ebebeb;
        border-radius: 8px;
        background-color: var(--color-white);
    }
</style>
